import { combineEpics } from 'redux-observable';
import type { State, Action } from '../state/types';
import { epic as loadDataEpic } from './load-data';

export default combineEpics<Action, State>(loadDataEpic);
